import React, { PureComponent } from 'react';
import { Num } from './Num';
import { BaseInputProps } from '../types';
import classNames from 'classnames';

export interface NumRangeFromToProps extends BaseInputProps {
  value?: { from?: number; to?: number };

  onChange?(val?: { from?: number; to?: number }): void;

  minName?: string;

  toName?: string;

  isPercentage?: boolean;
}

export class NumRangeFromTo extends PureComponent<NumRangeFromToProps> {
  onChange = (key: 'from' | 'to', val: number) => {
    const value = { ...this.props.value } as any;
    value[key] = val;
    this.props.onChange?.(value);
  };

  render() {
    return (
      <div
        className={classNames(
          'flex',
          'gap-1',
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? '(' : ''}
        <Num
          placeholder={'From'}
          value={this.props.value?.from}
          onChange={this.onChange.bind(null, 'from')}
          isPercentage={this.props.isPercentage}
          readonly={this.props.readonly}
          onBlur={this.props.onBlur}
        />
        <span
          style={
            this.props.readonly ? { marginLeft: 0, marginRight: 4 } : undefined
          }
        >
          {this.props.readonly ? ',' : '~'}
        </span>
        <Num
          placeholder={'To'}
          value={this.props.value?.to}
          onChange={this.onChange.bind(null, 'to')}
          isPercentage={this.props.isPercentage}
          readonly={this.props.readonly}
          onBlur={this.props.onBlur}
        />
        {this.props.readonly ? ')' : ''}
      </div>
    );
  }
}
